/*
*  connecting a table with database for doctors
* appears in <div class="database__main" id="database" data-controller="database"></div>
*/


import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import Twig from 'twig'
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css'
import 'select2/dist/js/select2.min'
import 'select2/dist/css/select2.min.css'
import {Modal} from "bootstrap";


export default class extends Controller {
    table;
    WhoIs;
    doctorsList = [];
    doctors = [];
    managers = [];
    storeCode;
    currentDocName;


    fullDoctorList = [];
    filteredDoctorList = [];

    initialize(){
        super.initialize();
        //we turn to twig, indicate which controller to use, inside we transfer the data
        let content = Twig.twig({ref: "database"}).render({});

        let token = sessionStorage.getItem('token');
        if (token === null ){
            this.logout();
        }

        //specify the block and display the contents of the twig in it
        $('#database').html(content);

        this.getDataList();
    }

    //checking authorization
    checkToken(){
        let token = sessionStorage.getItem('token');
        if (token !== null ){
            this.WhoIs = api.WhoIs();
            if(this.WhoIs.status === 500) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('userId');
                let nameVar = Twig.twig({ref: "authorization"}).render({});
                $('#authorization').html(nameVar)
            }
        } else {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('userId');
            let nameVar = Twig.twig({ref: "authorization"}).render({});
            $('#authorization').html(nameVar)
        }
    }

    //logout
    logout(){
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userId');
        let nameVar = Twig.twig({ref: "authorization"}).render({});
        $('#authorization').html(nameVar)
    }



    /* !!!!!!!! GO TO PAGE !!!!!!!!!!!!!! */

    goToDatabase() {
        this.checkToken();
        $('#titlePageBox').remove();
        $('#database').remove();
        $('#form-creation').remove();
        $('#my-schedule').remove();
        $('#userdoc').remove();
        $('.xdsoft_datetimepicker').remove();
        $('#headerContentTitle').html('Список пациентов');
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center title-page__box" id="titlePageBox">' +
            /*'<h1 class="title-page">Список пациентов</h1>' +*/
            '<div class="ms-auto" data-controller="database">' +
                '<button type="button" class="btn btn-light btnIcon" data-action="click->database#showMySchedule"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> Расписание</button>' +
                '<button type="button" class="btn btn-light" data-action="click->database#addNewForm">Заполнить новую форму</button>' +
            '</div>' +
            '</div>' +
            '<div class="container-fluid database__main" id="database" data-controller="database"></div>');
    }

    addNewForm() {
        this.checkToken();
        $('#titlePageBox').remove();
        $('#database').remove();
        $('#form-creation').remove();
        $('#my-schedule').remove();
        $('#userdoc').remove();
        $('.xdsoft_datetimepicker').remove();
        $('#headerContentTitle').html('Карта пациента');
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center title-page__box" id="titlePageBox">' +
                /*'<h1 class="title-page">Карта клиента оптики</h1>' +*/
                '<div class="ms-auto" data-controller="database">' +
                    '<button type="button" class="btn btn-light" data-action="click->database#goToDatabase">Список пациентов</button>' +
                '</div>' +
            '</div>' +
            '<div class="container-fluid form__main" id="form-creation" data-controller="form-creation"></div>');
    }

    addNewFormFromSchedule(event) {
        $('#titlePageBox').remove();
        $('#database').remove();
        $('#form-creation').remove();
        $('#my-schedule').remove();
        $('#userdoc').remove();
        $('.xdsoft_datetimepicker').remove();
        $('#headerContentTitle').html('Карта пациента');
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center title-page__box" id="titlePageBox">' +
            /*'<h1 class="title-page">Карта клиента оптики</h1>' +*/
            '<div class="ms-auto" data-controller="database">' +
            '<button type="button" class="btn btn-light" data-action="click->database#goToDatabase">Список пациентов</button>' +
            '</div>' +
            '</div>' +
            '<div class="container-fluid form__main" id="form-creation" data-controller="form-creation" data-fromSchedule="addFromSchedule" ' +
            'data-name="'+event.params.name+'" ' +
            'data-surname="'+event.params.surname+'" ' +
            'data-pnone="'+event.params.pnone+'" ' +
            'data-datebirth="'+event.params.datebirth+'"' +
            '></div>');
    }

    //go to the page of the questionnaire for the patient
    goToDoc(event) {
        this.checkToken();
        $('#titlePageBox').remove();
        $('#database').remove();
        $('#form-creation').remove();
        $('#my-schedule').remove();
        $('#userdoc').remove();
        $('.xdsoft_datetimepicker').remove();
        $('#headerContentTitle').html('Анкета #'+event.params.id+' от '+event.params.date+'');
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center title-page__box d-print-none" id="titlePageBox">' +
               /* '<h1 class="title-page">Консультативный лист #'+event.params.id+' от '+event.params.date+'</h1>' +*/
                '<div class="ms-auto" data-controller="database">' +
                    '<button type="button" class="btn btn-light" data-action="click->database#goToDatabase">Список пациентов</button>' +
                '</div>' +
            '</div>' +
            '<div class="container-fluid form__main" id="userdoc" data-controller="userdoc" data-form="'+ event.params.id +'"></div>');
    }

    //go to the shedule doctor
    showMySchedule(){
        $('#titlePageBox').remove();
        $('#database').remove();
        $('#form-creation').remove();
        $('#my-schedule').remove();
        $('#userdoc').remove();
        $('.xdsoft_datetimepicker').remove();
        $('#headerContentTitle').html('Мое расписание');
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center title-page__box" id="titlePageBox">' +
            /*'<h1 class="title-page">Мое расписание</h1>' +*/
                '<div class="ms-auto" data-controller="database">' +
                    '<button type="button" class="btn btn-light" data-action="click->database#goToDatabase">Список пациентов</button>' +
                    '<button type="button" class="btn btn-light" data-action="click->database#addNewForm">Заполнить новую форму</button>' +
                '</div>' +
            '</div>' +
            '<div class="container-fluid database__main" id="my-schedule" data-controller="my-schedule"></div>');
    }

    /* !!!!!!!! end GO TO PAGE !!!!!!!!!!!!!! */

   //show-hide additional info - generate a line waiting for the output
    showHideAddInfo(event){
        //console.debug('event');
            let tr = $(event.target).closest('tr');
            let row = this.table.row(tr);
            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(this.showAddInfo(row.data(), event.params.id)).show();
                tr.addClass('shown');
            }
    }

    //additional information for people - a list of previously completed questionnaires
    showAddInfo(d, id){
        $(".database-addInfo").click(function(event) {
            let clickId = event.target.id;
        });
        let links =  api.profileList(id);
        let data = d;
        let currentUserId = sessionStorage.getItem('userId');
        let options = links.reduce((html, link, currentIndex) => {
            console.debug(link);
            let currentIndexItem = currentIndex +1;
            let CreateAnketaDate = new Date(link.date).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty", hour: "2-digit", minute: "2-digit" });
                let anketaEmpty = '';
/*            if (link.noData){
                anketaEmpty = 'anketaEmpty'
            }*/

           html += '' +
            '<li class="list-group-item databaseList__anketa-list"><div class="databaseList__anketa-list-item" id="receiptNum'+ link.id + '">' +
            ' <button type="button" class="btn btn-link ' + anketaEmpty + '" data-action="click->database#goToDoc" data-database-id-param="'+ link.id + '" data-database-date-param="' +CreateAnketaDate +'"> Анкета № ' + link.id +' от '+ CreateAnketaDate + '</button>'
            let userAnketaItem =  api.getAnketa(link.id);
            //console.debug(userAnketaItem);
            if (currentIndexItem === 1)  {

                let receiptGlassList = userAnketaItem.ReceiptGlass;
                receiptGlassList.forEach((item)=>{
                    if (item.receteNo !== undefined){

                        html +=
                        '<p class="databaseList__receiptNum">Рецепт № '+item.receteNo+'</p>';
                    }
                });
            /*}  */
            html += '</div><div class="databaseList__anketa-list-item">'
          /*  if (currentIndexItem === 1)  {*/
                html +=
                    '<button type="button" class="btn btn-edit" data-action="click->database#copyForm"  data-database-id-param="'+ link.id + '">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg> Копировать</button>'
            } /*else {
                html +=
                    '<button type="button" class="btn btn-edit invisible" disabled>' +
                    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg> Копировать</button>'
            }*/
            html += '</div><div class="databaseList__anketa-list-item">'

            if (link.createdBy === Number(currentUserId) || userAnketaItem.CreatedBy === Number(currentUserId) ) {
                html += '<button type="button" class="btn btn-edit" data-action="click->database#editForm" data-database-id-param="'+ link.id + '" data-database-patientId-param="'+ link.patientId + '"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>Редактировать</button>'
            } else {
                html += '<button type="button" class="btn btn-edit invisible" disabled><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>Редактировать</button>'
            }
            html += '</div><div class="databaseList__anketa-list-item">'


            if (link.createdBy === Number(currentUserId) ) {
                html += '<button type="button" class="btn btn-delete" data-bs-toggle="modal" data-bs-target="#deleteAnketaModal-' + link.id +'"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-delete"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line></svg> Удалить</button>' +
                    '<div class="modal fade" id="deleteAnketaModal-' + link.id +'" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">' +
                    '<div class="modal-dialog modal-dialog-centered">' +
                    '<div class="modal-content">' +
                    '<div class="modal-header">' +
                    '<h5 class="modal-title">АНКЕТА № '+ link.id +'<br>От '+ CreateAnketaDate +'</h5><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' +
                    '</div>' +
                    '<div class="modal-body"><p>Вы точно хотите удалить анкету из базы?</p></div>' +
                    '<div class="modal-footer"><button type="button" class="btn btn-primary" data-bs-dismiss="modal">Нет, не удалять анкету</button><button type="button" data-action="click->database#deleteForm" data-database-id-param="'+ link.id + '" class="btn btn-danger"  data-bs-dismiss="modal">удалить анкету</button></div>' +
                    '</div>' +
                    '</div>' +
                    '</div>'
            } else {
                html += '<button type="button" class="btn btn-delete invisible" disabled><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-delete"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line></svg> Удалить</button>'
            }
            html += '</div><div class="databaseList__anketa-list-item">'
            if (link.createdBy === Number(currentUserId) ) {
              /*  if (currentIndexItem === 1)  {*/
                    html +=
                        '<button type="button" class="btn btn-toweb" data-action="click->database#towebForm"  data-database-id-param="'+ link.id + '">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-toweb"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg> Записать в web</button>' +
                        '                        <div class="modal fade" id="towebForm'+ link.id + '" tabindex="-1" aria-hidden="true">\n' +
                        '                            <div class="modal-dialog">\n' +
                        '                                <div class="modal-content">\n' +
                        '                                    <div class="modal-header">\n' +
                        '                                        <h5 class="modal-title">Рецепты зарегистрированы</h5>\n' +
                        '                                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>\n' +
                        '                                    </div>\n' +
                        '                                    <div class="modal-body">\n' +
                        '                                        <div class="col-sm-12 mt-3">' +
                        '<ul id="towebFormList'+ link.id + '"></ul></div>\n' +
                        '                                    </div>\n' +
                        '                                </div>\n' +
                        '                            </div>\n' +
                        '                        </div>'
                }
           /* }*/

            html +=
            '</div></li>'
            return html
        }, '' )
        return (
            '<ol class="list-group list-group-numbered list-group-striped">' +
            options +
            '</ol>'
        );
    }



    // edit client medical questionnaire
    editForm(event) {
        this.checkToken();
        $('#titlePageBox').remove();
        $('#database').remove();
        $('#userdoc').remove();
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center mb-3 title-page__box" id="titlePageBox">' +
            '<h1 class="title-page">Карта клиента оптики</h1>' +
            '<div class="ms-auto" data-controller="database">' +
            '<button type="button" class="btn btn-light" data-action="click->database#goToDatabase">База данных клиентов</button>' +
            '</div>' +
            '</div>' +
            '<div class="container-fluid form__main" id="form-creation" data-controller="form-creation" data-form="'+ event.params.id +'" data-patientId="'+ event.params.patientid +'" data-form-edit="edit"></div>');
    }

    // copy client medical questionnaire
    copyForm(event) {
        this.checkToken();
        $('#titlePageBox').remove();
        $('#database').remove();
        $('#userdoc').remove();
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center mb-3 title-page__box" id="titlePageBox">' +
            '<h1 class="title-page">Карта клиента оптики</h1>' +
            '<div class="ms-auto" data-controller="form-creation">' +
            '<button type="button" class="btn btn-light" data-action="click->database#goToDatabase">База данных клиентов</button>' +
            '</div>' +
            '</div>' +
            '<div class="container-fluid form__main copyFormActive" id="form-creation" data-controller="form-creation" data-form="'+ event.params.id +'" data-form-edit="copy"></div>');
    }

    // delete client medical questionnaire
    deleteForm(event){
        this.checkToken();
        let deleteForm = api.deleteAnketa(event.params.id);
        this.table.row($('#row-' + event.params.idpatient)).remove().draw();
    }

    // delete client
    deletePatient(event){
        this.checkToken();
        let deleteForm = api.deletePatient(event.params.idpatient);
        this.table.row($('#row-' + event.params.idpatient)).remove().draw();
    }

    //send the patient's medical questionnaire to the WEB database
    towebForm(event){
        //disabled button in anketa while method worked
        $('#anketaBtnBox button').attr('disabled','disabled');

        //disabled button in database while method worked
        $('#row-'+event.params.id+' .databaseList__anketa-list-item button').attr('disabled','disabled');

        $.ajax({
            type: "post",
            url: global.api_url + '/patient/web/'+ event.params.id,
            contentType: "application/json",
            success: function(data){
                 if (data !== undefined || data.length > 0 ){
                        const myModal = new Modal('#towebForm'+event.params.id);
                        $('#towebFormList'+event.params.id).html('');
                     $('#towebForm'+event.params.id+' .modal-title').text('Рецепты зарегистрированы');
                        $('#anketaBtnBox button').attr('disabled',false);
                        $('#row-'+event.params.id+' .databaseList__anketa-list-item button').attr('disabled',false);
                         myModal.show();
                         data.forEach((item)=>{
                        $('#towebFormList'+event.params.id).append('<li>Рецепт №'+ item.replace(/['"«»]/g, '') +'</li>');
                    });
                 } else {
                     const myModal = new Modal('#towebForm'+event.params.id);
                     $('#towebFormList'+event.params.id).html('');
                     $('#anketaBtnBox button').attr('disabled',false);
                     $('#row-'+event.params.id+' .databaseList__anketa-list-item button').attr('disabled',false);
                     myModal.show();
                     $('#towebForm'+event.params.id+' .modal-title').text('Рецепты не зарегистрированы - success кусок');
                     $('#towebFormList'+event.params.id).append('<li>База WEB не отвечает. Пожалуйста, попробуйте позже.</li>');
                 }
            },
            error:function (data){
                const myModal = new Modal('#towebForm'+event.params.id);
                $('#towebFormList'+event.params.id).html('');
                $('#anketaBtnBox button').attr('disabled',false);
                $('#row-'+event.params.id+' .databaseList__anketa-list-item button').attr('disabled',false);
                myModal.show();
                $('#towebForm'+event.params.id+' .modal-title').text('Рецепты не зарегистрированы');
                $('#towebFormList'+event.params.id).append('<li>База WEB не отвечает. Пожалуйста, попробуйте позже.</li>');
            }
        });

    }



    //list of doctors to filter
    getDoctorsList(){
        self = this;
        let managersSalon = [];
        this.doctorsList = $('#js-doctors-list[name="doctors[]"]').val();
        this.doctorsList.forEach((id)=>{
            let storeCode = self.doctors.find((doctor) => doctor.StaffID.toString() === id).StoreCode;
            managersSalon = self.managers.filter((val)=>{
                return val.StoreCode === storeCode
            });
        });
        managersSalon.forEach((element)=>{
            this.doctorsList.push(element.StaffID.toString());
        });
 /*       console.debug(this.doctorsList);*/
        this.table.draw();
    }

    //clear Filter
    clearFilter(){
        $('#js-doctors-list').val(null).trigger('change');
        this.doctorsList = [];
        this.table.draw();
    }

    //create:  filter, database table
    getDataList(){

    /*    let currentDoctorId = sessionStorage.getItem('userId');
        let currentDoctorIdNum = Number(currentDoctorId);*/
        let jsDoctorList = $('#js-doctors-list');

        //создаем список врачей в селекте
        if(this.doctors.length === 0){
            this.doctors = api.doctorList('doctor');
        }

        if(this.managers.length === 0){
            this.managers = api.doctorList('manager');
        }


        this.doctors.forEach((item)=>{
            jsDoctorList.append('<option value="'+item.StaffID+'">'+item.Name+' ('+item.StoreCode+')</option>');
          /*  if (currentDoctorIdNum === item.StaffID){
                jsDoctorList.append('<option value="'+item.StaffID+'" selected="selected">'+item.Name+' ('+item.StoreCode+')</option>');
                this.storeCode = item.StoreCode;
            } else {
                jsDoctorList.append('<option value="'+item.StaffID+'">'+item.Name+' ('+item.StoreCode+')</option>');
            }*/
        });

        jsDoctorList.select2({
            placeholder: 'Нажмите, чтобы выбрать врача/врачей'
        });

        let storeDoctorList = this.doctors/*.filter((val)=>{
            return val.StoreCode === this.storeCode
        });*/


        //показываем записи только текущего доктора
        //this.doctorsList = [currentDoctorId];
      /*  storeDoctorList.forEach((element)=>{
            this.doctorsList.push(element.StaffID.toString());
        });*/

        $.fn.dataTable.ext.errMode = 'none';
        self =  this;

        this.table = $('#databaseList').DataTable({
            language: {
                url: 'data/dataTables.ru.json'
            },
            serverSide: true,
            processing: true,

            ajax: {
                url: global.api_url + '/patient/datatable',
                headers: {'Authorization': 'Bearer '+ sessionStorage.getItem('token')},
                type: 'post',
                data: (data)=>{
                    if(self.doctorsList.length !== 0 ){
                        data.doctorFilter = self.doctorsList;
                        //console.debug(data.doctorFilter);
                    } else{
                        data.doctorFilter = null;
                    }
                    data.userType = 'doctor';
                    //console.debug(data.doctorFilter);
                    return JSON.stringify(data)
                },
                contentType: "application/json",

                error: (error)=>{
                    console.debug(error);
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('userId');
                    document.location.reload();
                }
            },
            columns: [
                {
                    /*className: 'dt-control',*/
                    orderable: false,
                    searchable: false,
                    data: null,
                    render: ((data, type, full, meta)=>{
                        //console.debug(full);
                        return '<span class="dt-control button-action database-addInfo" data-action="click->database#showHideAddInfo" id="' + full.id +'" data-database-id-param="' + full.id +'"></span>'
                    })
                },
                {   data: 'id',
                    title: 'ID',
                    searchable: false,
                    orderable: false
                },
                {   data: 'client_name',
                    title: 'Имя',
                    searchable: true,
                    orderable: true
                },
                {   data: 'client_surname',
                    title: 'Фамилия',
                    searchable: true,
                    orderable: true
                },
                {   data: 'client_date_birth',
                    render: ((data, type, full, meta)=>{
                        return new Date(data).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" })
                    }),
                    title: 'Дата рождения',
                    searchable: true,
                    orderable: true
                },
                {   data: 'phone',
                    title: 'Телефон',
                    searchable: true,
                    orderable: true
                },
                {   data: 'created_by',
                    render: ((data, type, full, meta)=>{
                        let doctorName = self.doctors.filter(function(val) {
                            return val.StaffID == data;
                        });
                        if (doctorName[0] !== undefined){
                            //return doctorName[0].Name + ' (ID '+data+ ') '
                            return 'ID '+data
                        }
                        doctorName = self.managers.filter(function(val) {
                            return val.StaffID == data;
                        });
                        if (doctorName[0] !== undefined){
                           //return doctorName[0].Name + ' (ID '+data+ ') '
                            return 'ID '+data
                        }
                        //return 'Нет имени регистратора (ID '+data+ ')'
                        return 'ID '+data
                    }),
                    title: '',
                    searchable: true,
                    orderable: true,
                },
                /*{

                    title: 'Edit',
                    orderable: false,
                    searchable: false,
                    data: null,
                    render: ((data, type, full, meta)=>{
                        return '<span class="button-action" data-action="click->database#editPatient" data-database-idpatient-param="' + full.id +'"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>\n' +
                            '</span>'
                    })
                },*/
                {
                    /*className: 'dt-control',*/
                    title: 'Del',
                    orderable: false,
                    searchable: false,
                    data: null,
                    render: ((data, type, full, meta)=>{
                        let currentUserId = sessionStorage.getItem('userId');
                        if (data.created_by === Number(currentUserId) ) {
                            return '<button type="button" class="button-action icon-delete" data-bs-toggle="modal" data-bs-target="#deleteModal-' + full.id +'">\n' +
                                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-delete"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line></svg>' +
                                '</button>\n' +
                                '<div class="modal fade" id="deleteModal-' + full.id +'" tabindex="-1" aria-hidden="true">\n' +
                                '  <div class="modal-dialog modal-dialog-centered">\n' +
                                '    <div class="modal-content">\n' +
                                '      <div class="modal-header">\n' +
                                '        <h5 class="modal-title" id="exampleModalLabel">ПАЦИЕНТ: <br>' +
                                '' + full.client_name +' ' +
                                '' + full.client_surname +'' +
                                '</h5>\n' +
                                '        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>\n' +
                                '      </div>\n' +
                                '      <div class="modal-body">\n' +
                                '<p>Вы точно хотите удалить пациента из базы?</p>' +
                                '<p>Вместе с пациентом будут удалены все его анкеты.</p>' +
                                '      </div>\n' +
                                '      <div class="modal-footer">\n' +
                                '        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Нет, не удалять пациента</button>\n' +
                                '        <button type="button"  data-action="click->database#deletePatient" data-database-idpatient-param="' + full.id +'" class="btn btn-danger"  data-bs-dismiss="modal">удалить пациента</button>\n' +
                                '      </div>\n' +
                                '    </div>\n' +
                                '  </div>\n' +
                                '</div>'
                        } else {
                            return '<button type="button" class="button-action icon-delete invisible"  disabled>\n' +
                                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-delete"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line></svg>' +
                                '</button>\n'
                        }

                    })
                }

            ],
        });
    }



    connect(){



    }
}
